import { Action, initialState, State } from 'store/store';
import {
  getAllTopicsOrdered,
  getInteractionsFromTopicAndState,
} from 'selectors/block';
import getBlockById from 'services/apiHelpers/getBlockById';

export const preprocessModule = (
  state: State = initialState,
  { data }: Action
): State => {
  const topics = getAllTopicsOrdered(state.blocks);
  const nextInteractionMap = {};

  // console.log('preprocessModule', topics);

  topics.forEach(topic => {
    const interactions = getInteractionsFromTopicAndState(
      state as any,
      (Object.values(state.blocks) as any).find(($: any) => $.id === topic.id)
    );

    interactions.forEach((interaction, index) => {
      if (index != interactions.length - 1) {
        nextInteractionMap[interaction.id] = interactions[index + 1].id;
      }
    });
  });

  // console.log({ nextInteractionMap });

  // const interactions = getInteractionsFromTopicAndState(
  //   state as any,
  //   (Object.values(blocks) as any).find(($: any) => $.id === currentTopic)
  // );

  // const nextInteraction =
  //   interactions[interactions.findIndex((i: any) => i.id === data) + 1];

  // if (!nextInteraction) return state;

  // const nextInteractionId = nextInteraction && nextInteraction.id;

  return { ...state, ...data, ...{ nextInteractionMap } };
};
